export type IConfig = typeof config;
export const config = {
  environment: process.env.REACT_APP_ENVIRONMENT as string,
  apiUrl: process.env.REACT_APP_API_URL as string,
  idpAuthority: {
    noordhoff: process.env.REACT_APP_IDP_AUTHORITY_NOORDHOFF as string,
    plantyn: process.env.REACT_APP_IDP_AUTHORITY_PLANTYN as string,
    liber: process.env.REACT_APP_IDP_AUTHORITY_LIBER as string,
  },
  idpClient: process.env.REACT_APP_IDP_CLIENT as string,
  instrumentationKey: process.env.REACT_APP_INSIGHTS_IKEY as string,
  basePath: '/',
  imagePath: 'assets/images',
  externalLogin: {
    plantyn: 'https://so.scoodle.be/account/deeplink?url=',
    liber: 'https://online.liber.se/'
  },
  breadcrumbLocalstorageKey: 'index-breadcrumbs',
  searchHistoryLocalstorageKey: 'search-history',
  lastViewedMapsLocalstorageKey: 'last-viewer-maps',
  selectedOpcoLocalstorageKey: 'selected-opco',
  businessUnitKey: 'nlp-business-unit',
  comaEnabledLocalStorageKey: 'content-manager-enabled',
  showUnsavedProjectChangesDialogLocalstorageKey:
    'show-unsaved-project-dialog',
  showWantToEditSharedProjectDialogLocalstorageKey:
    'show-edits-shared-project-dialog',
  selectedLicenceLocalstorageKey: 'selectedLicence',
  hideShareDialogWarningLocalstorageKey: 'HIDE_SHARE_INFO',
  useExperimentalFeaturesKey: 'experimental_features_enabled',
  searchHistoryMaxItems: 9,
  lastViewedMaxItems: 3,
  minZoom: 2,
  maxZoom: 4,
  googleMapsApiKey: 'AIzaSyD-zOK_tQDBHV_P6dD6gnHZfcEbjl-0_ZY',
  cloudinaryCloudName: process.env.REACT_APP_CLOUDINARY_CLOUD_NAME as string,
  tabletBreakpoint: 1024,
  configcat: {
    featuresKey: process.env.REACT_APP_CONFIGCAT_FEATURESKEY as string,
    settingsKey: process.env.REACT_APP_CONFIGCAT_SETTINGSKEY as string
  },
  feedbackServiceUrl: process.env.REACT_APP_FEEDBACKSERVICE_URL as string,
  minCharactersForSearch: 3
} as const;
